import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Deborah Grooff',
  role: 'Fijnproever',
  text: "Awesome Taste, Great quality! Wonderbaarlijk hoe de smaak hetzelfde is gebleven als bij de 'verse' Madame Jeanette. Vriendelijk in gebruik en scheelt een hoop rompslomp. Echt een aanrader!",
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1887&auto=format&fit=crop'
}, {
  id: 2,
  name: 'Michael V.',
  role: 'Hobbykok',
  text: 'Eindelijk een product dat de echte Surinaamse hitte en smaak levert zonder dat ik telkens verse pepers hoef te zoeken. De vlokken zijn perfect te doseren.',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=1887&auto=format&fit=crop'
}, {
  id: 3,
  name: 'Sarah K.',
  role: 'Foodblogger',
  text: 'De Fong Fong Pepre is een absolute must-have in mijn kruidenrek. Het geeft net die extra kick aan mijn gerechten die ik zocht. Prachtige verpakking ook!',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=2070&auto=format&fit=crop'
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => {
    setCurrentIndex(prev => (prev + 1) % testimonials.length);
  };
  const prev = () => {
    setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  return <section className="py-24 bg-brand-cream relative overflow-hidden" data-id="element-246">
      {/* Decorative background text */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[15vw] font-serif font-bold text-black/[0.02] whitespace-nowrap pointer-events-none select-none" data-id="element-247">
        REVIEWS
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-248">
        <div className="text-center mb-16" data-id="element-249">
          <Quote className="w-12 h-12 text-brand-orange mx-auto mb-6 opacity-50" data-id="element-250" />
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark" data-id="element-251">
            Wat Onze Klanten Zeggen
          </h2>
        </div>

        <div className="relative" data-id="element-252">
          <div className="overflow-hidden" data-id="element-253">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${currentIndex * 100}%)`
          }} data-id="element-254">
              {testimonials.map(testimonial => <div key={testimonial.id} className="w-full flex-shrink-0 px-4" data-id="element-255">
                  <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm text-center" data-id="element-256">
                    <p className="text-xl md:text-2xl font-serif italic text-brand-dark mb-8 leading-relaxed" data-id="element-257">
                      "{testimonial.text}"
                    </p>
                    <div className="flex flex-col items-center" data-id="element-258">
                      <img src={testimonial.image} alt={testimonial.name} className="w-16 h-16 rounded-full object-cover mb-4 border-2 border-brand-cream" data-id="element-259" />
                      <h4 className="font-bold text-brand-dark tracking-wide uppercase text-sm" data-id="element-260">
                        {testimonial.name}
                      </h4>
                      <span className="text-brand-gray text-sm" data-id="element-261">
                        {testimonial.role}
                      </span>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Controls */}
          <button onClick={prev} className="absolute top-1/2 -left-4 md:-left-12 -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-md flex items-center justify-center text-brand-dark hover:text-brand-red hover:scale-110 transition-all" data-id="element-262">
            <ChevronLeft size={24} data-id="element-263" />
          </button>
          <button onClick={next} className="absolute top-1/2 -right-4 md:-right-12 -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-md flex items-center justify-center text-brand-dark hover:text-brand-red hover:scale-110 transition-all" data-id="element-264">
            <ChevronRight size={24} data-id="element-265" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8" data-id="element-266">
          {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 rounded-full transition-all ${idx === currentIndex ? 'bg-brand-red w-8' : 'bg-brand-gray/30 hover:bg-brand-gray'}`} data-id="element-267" />)}
        </div>
      </div>
    </section>;
}